import GrComponentFactory from "../gr_component_factory";
import { isEmpty } from "lodash";
import classNames from "classnames";
import React from "react";

export default GrComponentFactory.createClass({
  displayName: "ReadingNotesLink",

  defaultProps: {
    className:"",
    countTextClassName: "",
    hasSharedContent: false,
    readingNotesVisibilityText: "",
  },

  propTypes: {
    className: React.PropTypes.string,
    countTextClassName: React.PropTypes.string,
    hasSharedContent: React.PropTypes.bool,
    readingNotesCountText: React.PropTypes.string.isRequired,
    readingNotesUrl: React.PropTypes.string.isRequired,
    readingNotesVisibilityText: React.PropTypes.string,
  },


  render() {
    const className = classNames(this.props.className);
    const readingNotesIconClassname = classNames("gr-icon",
                                               "u-verticalAlignTop",
                                               "gr-icon--readingNotesIcon",
                                               { "gr-icon--readingNotesIcon--white" : !this.props.hasSharedContent });
    const countTextClassName = classNames("u-inlineBlock", this.props.countTextClassName);
    const countText = this.props.readingNotesCountText;
    const visibilityText = this.props.readingNotesVisibilityText;
    const readingNoteUrl = this.props.readingNotesUrl;
    return (
      <div className={className}>
        <div className={readingNotesIconClassname}>
          <span className="u-visuallyHidden">Note</span>
        </div>
        <div className={countTextClassName}>
          <a href={readingNoteUrl}>
            {countText}
          </a>
          { isEmpty(visibilityText) ?
            null : <span className="u-displayBlock gr-metaText">{visibilityText}</span>
          }
        </div>
      </div>
    );
  },
});
